import React, { useState, useEffect, useMemo } from 'react';
import { Spin, Tabs } from 'antd';
import { useLocation } from 'react-router-dom';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import ExternalMarketing from './components/ExternalMarketing';
import KlarityMarketing from './components/KlarityMarketing';
import { shouldUseKlarityUi, isPPAOnboardingCompleted } from 'utils/common';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';
import AIChat from 'components/AIChat';
import { EAIChatPageId } from 'types/ai';
import { EFeatureType } from 'types/provider';
import MarketingLandingPage from './components/MarketingLandingPage';

const MarketingPage: React.FC = () => {
    const location = useLocation();
    const [tabKey, setTabKey] = useState('klarity');
    const [homeInfo, loadingHomeInfo, refetchHomeInfo] = useProviderHomeInfo();
    const hasCredentialing = !!homeInfo?.features?.includes(EFeatureType.KLARITY_CREDENTIALING);
    // live or paused listings always get the real Marketing tab, even if Advanced Settings (STEP_21) was never finished
    const listedOrPaused = ['L', 'PL'].includes(homeInfo?.listingStatus ?? '');
    const showLandingPage = !listedOrPaused && !isPPAOnboardingCompleted(homeInfo);

    const showKlarityUi = shouldUseKlarityUi(homeInfo);

    // 使用 useMemo 优化 searchParams 创建
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const subTab = searchParams.get('subTab');

    const tabItems = [
        { key: 'klarity', label: 'Klarity marketing', children: <KlarityMarketing /> },
        { key: 'external', label: 'External marketing', children: <ExternalMarketing defaultSubTab={subTab} /> },
    ];

    useEffect(() => {
        const mainTab = searchParams.get('mainTab');
        if (mainTab && tabItems.some((item) => item.key === mainTab)) {
            setTabKey(mainTab);
        }
    }, [searchParams]);

    const handleTabClick = (key: string) => {
        setTabKey(key);
    };
    if (!homeInfo) {
        return <Spin />;
    }
    if (showLandingPage) {
        return (
            <div className={s.wrap} style={{ padding: '0px 32px' }}>
                <MarketingLandingPage />
            </div>
        );
    }

    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <div className={s.inner}>Marketing</div>
            </div>
            <div className={s.content}>
                {showKlarityUi && <KlarityMarketing />}
                {!showKlarityUi && <Tabs activeKey={tabKey} items={tabItems} onTabClick={handleTabClick} />}
            </div>
            <div className={commonS.chatWrap}>
                <AIChat pageId={EAIChatPageId.PROVIDER_MARKETING} defaultShow={false} makeFix={false} />
            </div>
        </div>
    );
};

export default MarketingPage;
